import { Injectable } from '@angular/core';

import * as fromRoot from '@app/reducers';
import { getProtocolHostnameAndPort, isAppDomain } from '@app/shared/helpers/location';
import { addOrUpdateUrlParam } from '@app/shared/helpers/urlHelper';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { map, take, withLatestFrom } from 'rxjs/operators';
import { Constant } from 'src/constant';
import { encodeSamlRequest } from 'smash-saml';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DomainSigninRedirectionGuard  {

  constructor(private store$: Store<fromRoot.State>) { }

  canActivate(): Observable<boolean> {
    return this.chechLoginRedirection().pipe(map((res) => {
      return res;
    }));
  }

  chechLoginRedirection(): Observable<boolean> {
    const stayHere$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      withLatestFrom(
        this.store$.select(fromRoot.getCurrentDomain),
        this.store$.select(fromRoot.selectServices),
        this.store$.select(fromRoot.getCurrentDomainProviders),
      ),
      take(1),
    ).subscribe(([state, currentDomain, { services }, providers]) => {
      if (currentDomain?.options?.redirection?.value) {
        const redirectTo = currentDomain.options.redirection.value;
        switch (redirectTo) {
          case Constant.domainLoginRedirection.None:
            stayHere$.next(true);
            break;
          case Constant.domainLoginRedirection.Signin:
            window.location.href = '/signin';
            stayHere$.next(false);
            break;
          case Constant.domainLoginRedirection.Provider:
            if (providers?.length > 0) {
              const idpUrl = providers[0].idpUrl;
              const audienceUris = providers[0].audienceUris;
              const consumerServiceUrl = services.find(service => service.name === 'iam' && service.region === currentDomain.region).url + '/saml/signon';
              const correspondingAudienceUri = isAppDomain() ? environment.appDomainWithProtocol : audienceUris.find(audienceUri => audienceUri === getProtocolHostnameAndPort());
              const SAMLRequest = encodeSamlRequest({ consumerServiceUrl, audienceUri: correspondingAudienceUri });
              window.location.href = addOrUpdateUrlParam(idpUrl, Constant.SAMLRequestKey, SAMLRequest);
              stayHere$.next(false);
              break;
            } else {
              window.location.href = '/signin';
              stayHere$.next(false);
              break;
            }
          default:
            stayHere$.next(true);
        }
      } else {
        stayHere$.next(true);
      }
    });
    return stayHere$.asObservable();
  }
}
